import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { OrderReturnsService } from '../../services/order-returns.service';

import {
  OrderReturnsActions,
  OrderReturnsActionsTypes, ReadReturnsReasons,
  ReadReturnsReasonsFailure,
  ReadReturnsReasonsSuccess,
} from './returns.actions';
import { ReturnReason } from '~app/modules/account/modules/orders-history/models/return-reason.model';

@Injectable()
export class ReturnsEffects {

  @Effect()
  readReasons$ = this.actions$.pipe(
    ofType(OrderReturnsActionsTypes.READ_RETURNS_REASONS),
    switchMap((action: ReadReturnsReasons) => this.returnsService
      .getReturnReasons(action.orderLineId)
      .pipe(map((data: ReturnReason[]) => new ReadReturnsReasonsSuccess(data)),
      catchError((error) => of(new ReadReturnsReasonsFailure(error))),
    )),
  );

  constructor(private actions$: Actions<OrderReturnsActions>,
              private returnsService: OrderReturnsService) {
  }
}
